import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { StudentService } from 'src/app/services/Student/student.service';
import * as moment from "moment"
@Component({
  selector: 'app-student-admin-status',
  templateUrl: './student-admin-status.component.html',
  styleUrls: ['./student-admin-status.component.css']
})
export class StudentAdminStatusComponent implements OnInit {
  BankList: any;
  Paid: any;
  Bank: any;
  FilePath: any;
  StudentModel = {
    RegistrationNumber: "",
    TestToDate: "",
    TestFormDate: "",
    Print: "",
    SubFormDate: '',
    AdmissionStatusID: '0',
    SubToDate: '',
    TestDt: '',
    TestVenue: "",
    TestTime:  moment(new Date()).format('DD-MMM-YYYY HH:mm'),
    ClassID: "0",
    ParentID: 0,
    Subject: " Admission Form Acknowledgement and Admit Card ",
    CC: "",
    TestVenueID: 0,
    FirstName: '',
    MiddleName: '',
    LastName: '',
    BODRegNo: '',
    StudentID: 0,
    EmailIDs: '',
    DefaultMailID:'',

  }

  ClearFilter(){
    this.StudentModel.SubFormDate='';
    this.StudentModel.SubToDate='';
    this.StudentModel.TestFormDate='';
    this.StudentModel.TestToDate='';
    this.StudentModel.ClassID='0';
    this.StudentModel.RegistrationNumber='';
    this.StudentModel.FirstName='';
    this.StudentModel.ParentID=0;
    this.StudentModel.AdmissionStatusID='0';
    this.StudentList=[];
  }
  BrothersAndSistersList: any;
  StudentDocumentList: any;
  IsTest = true;
  StudentPaymentModel = {
    FirstName: '',
    ChequeNo: "",
    ChequeDate: "",
    BankID: 0,
    StudentPhotoPath: "",
    Specialattention: "",
    Remarks: "",
    StudentID: 0,
    ClassID: 0,
    Amount: 0,
    PaidAmount: 0,
    RegistrationNumber: '',
    ReceiptNo: '',
    BankCharges: "",
    BankAccountID: 0,
    PaymentModeID: 0,
    MiddleName: "",
  }
  ReceiptNo: any;
  CourseList: any;
  TestStudentList = [];

  StudentEnquiryModel =
    {
      Address: '',
      RegistrationNumber: "",
      Specialattention: "",
      StudentPhotoPath: "",
      HealthCondition: "",
      ThirdLanguage: "",
      SpecialNeed: false,
      EmailID: '',
      HouseName: '',
      FirstName: "",
      StudentID: 0,
      MiddleName: '',
      LastName: '',
      Gender: '0',
      SessionID: 0,
      DOB: '',
      BODRegNo: '',
      BloodGroupID: 0,
      NationalityID: 0,
      PermanentCountry: '',
      PrevSchool: '',
      ReligionID: 0,
      PrevClassID: 0,
      PermanentCity: '',
      MotherTongue: '',
      BranchID: 0,
      MotherTongueID: 0,
      PlaceOfBirth: '',
      CasteID: 0,
      Religion: '',
      RelationShipID: 0,
      ClassID: 0,
      PresentCountryID: this.globalHelper.GetLoginToken().CountryID,
      BloodGroup: '',
      PassportNo: '',
      StreamID: 0,
      PassportExpiryDate: '',
      VisaExpiryDate: '',
      VisaNo: '',
      Nationality: '',
      PresentAddress: '',
      PresentStateID: 0,
      PresentCityID: 0,
      Mobile: '',
      PresentZipCode: '',
      PermanentAddress: '',
      PermanentCountryID: 0,
      PermanentStateID: 0,
      PermanentCityID: 0,
      PermanentZipCode: '',
      FatherName: '',
      FatherOccupation: '',
      FatherQualificationID: 0,
      FatherPresentAddress: '',
      FatherPermanentAddress: '',
      FatherCompanyName: '',
      FatherCompanyAddress: '',
      FatherContactHome: '',
      FatherContactCell: '',
      FatherContactOffice: '',
      FatherOfficeEmailID: '',
      FatherPersonalMailID: '',
      FatherPassportNo: '',
      FatherPassportExpiryDate: '',
      FatherVisaNo: '',
      FatherVisaExpiryDate: '',
      MotherName: '',
      MotherOccupation: '',
      MotherQualificationID: 0,
      MotherPresentAddress: '',
      MotherPermanentAddress: '',
      MotherCompanyName: '',
      MotherCompanyAddress: '',
      MotherContactWork: '',
      MotherContactHome: '',
      MotherContactCell: '',
      MotherContactOffice: '',
      MotherOfficeEmailID: '',
      MotherPassportNo: '',
      MotherPassportExpiryDate: '',
      MotherVisaNo: '',
      MotherVisaExpiryDate: '',
      DECLARATION: false,
      IDCardTypeID: 0,
      IDCardNo: '',
      EnquiryNo: '',
      ParentID: 0,
      CategoryID: '0',
      SpecialCategoryID: '0',
      LocationID: '0',
      FatherPhotoPath: "",
      MotherPhotoPath: "",
      MotherPersonalMailID: "",
      FatherContactWork: "",
      FatherDesignation: "",
      MotherDesignation: "",
      FatherNationality: "",
      MotherNationality: "",
      HouseNo: "",
      WayNo: "",
      StreetName: "",
      Locality: "",
      POBox: "",
      PresentCity:'',
      StudentNo:'',
      MonthlyIncome:0,
      SectionID:0,
      Active:false,
      FatherQualification:'',
      MotherQualification:'',
      GaurdianName:'',
      GaurdianAddress:'',
      GaurdianContact:'',
      AdmissionDate: moment(new Date()).format('DD-MMM-YYYY')
     

    };

    ClearModel(){
      this.StudentEnquiryModel.EnquiryNo = '';
      this.StudentEnquiryModel.FirstName = '';
      this.StudentEnquiryModel.MiddleName = '';
      this.StudentEnquiryModel.LastName = '';
      this.StudentEnquiryModel.Gender = '0';
      this.StudentEnquiryModel.DOB = '';
      this.StudentEnquiryModel.PlaceOfBirth = '';
      this.StudentEnquiryModel.NationalityID = 0;
      this.StudentEnquiryModel.ReligionID = 0;
      this.StudentEnquiryModel.SectionID = 0;
      this.StudentEnquiryModel.MotherTongueID = 0;
      this.StudentEnquiryModel.EmailID = '';
      this.StudentEnquiryModel.Mobile = '';
      this.StudentEnquiryModel.PrevClassID = 0;
      this.StudentEnquiryModel.CategoryID = '0';
      this.StudentEnquiryModel.SpecialCategoryID = '0';
      this.StudentEnquiryModel.PrevSchool = '';
      this.StudentEnquiryModel.ClassID = 0;
      this.StudentEnquiryModel.FatherName = '';
      this.StudentEnquiryModel.FatherOccupation = '';
      this.StudentEnquiryModel.MotherName = '';
      this.StudentEnquiryModel.MotherOccupation = '';
      this.StudentEnquiryModel.FatherContactCell = ''; 
      this.StudentEnquiryModel.MotherContactCell = ''; 
      this.StudentEnquiryModel.HouseNo = ''; 
      this.StudentEnquiryModel.StreetName = ''; 
      this.StudentEnquiryModel.WayNo = ''; 
      this.StudentEnquiryModel.Locality = ''; 
      this.StudentEnquiryModel.FatherContactWork = ''; 
      this.StudentEnquiryModel.FatherContactHome = ''; 
      this.StudentEnquiryModel.POBox = ''; 
      this.StudentEnquiryModel.PresentZipCode = ''; 
      this.StudentEnquiryModel.LocationID = '0'; 
      this.StudentEnquiryModel.PermanentAddress = ''; 
      this.StudentEnquiryModel.PresentAddress = '';
      this.SubmittedBasicDetails=false;
      this.StudentEnquiryModel.StudentID=0;
      this.StudentEnquiryModel.PresentCity='';
      this.StudentEnquiryModel.PresentStateID=0;
      this.StudentEnquiryModel.StreamID=0;
      this.StudentEnquiryModel.IDCardTypeID=0;
      this.StudentEnquiryModel.IDCardNo='';
      this.StudentEnquiryModel.Active=false;
      this.StudentEnquiryModel.StudentNo='';
      this.StudentEnquiryModel.MonthlyIncome=0;
      this.StudentEnquiryModel.FatherDesignation='';
      this.StudentEnquiryModel.FatherQualification='';
      this.StudentEnquiryModel.FatherCompanyName='';
      this.StudentEnquiryModel.FatherCompanyAddress='';
      this.StudentEnquiryModel.MotherQualification='';
      this.StudentEnquiryModel.MotherCompanyName='';
      this.StudentEnquiryModel.MotherCompanyAddress='';
      this.StudentEnquiryModel.MotherDesignation='';
      this.StudentEnquiryModel.GaurdianName='';
      this.StudentEnquiryModel.GaurdianAddress='';
      this.StudentEnquiryModel.GaurdianContact='';
      this.StudentEnquiryModel.AdmissionDate= moment(new Date()).format('DD-MMM-YYYY');
      this.StudentID='';
      
    }
  Mesg: any;
  StudentView: any;
  SubmittedBasicDetails = false;
  loading = false;
  ParentID: any;
  StaffIdentity: any;
  ParentAlert: any;
  ParentsDetails: any;
  StudentList: any;
  StudentDocumentModel = {
    DocumentID: "0",
    Notes: "",

  };
  DefaultMailID: any;
  hidePrint = false;
  SubmittedParents = false;
  loadingParents: any;
  DocumentList: any;
  SectionList: any;
  SelectedFileForStudentUpload: any;
  SelectedFileForFatherUpload: any;
  SelectedFileForMotherUpload: any;
  SelectedFileForDocumentUpload: any;
  StudentRegistrationModel = {
    StudentID: 0,
    PermanentCountryID: 0,
    PermanentStateID: 0
  };
  LocationList: any;
  PermanentStateList: any;
  PermanentCityList: any;
  PermanentCountryList: any;
  CategoryList: any;
  SpecialCategoryList: any;
  PresentCountryList: any;
  PresentStateList: any;
  PresentCityList: any;
  AcademicSessionList: any;
  BranchList: any;
  ClassList: any;
  BloodGroupList: any;
  MotherTongueList: any;
  ReligionList: any;
  NationalityList: any;
  RelationshipList: any;
  PaymentModeList: any;
  IDCardTypeList: any;
  TestVenueList: any;
  isCollapsed = true;
  IsResult = true;
  ActionButton = "ButtonInactive"
  constructor(private studentService: StudentService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }


  GetID(obj) {

    this.StudentRegistrationModel.StudentID = obj.StudentID;
    this.StudentEnquiryModel.ClassID = obj.ClassID;
    this.GetDocument();
    this.GetStudentProfileByStudentID();

  }
  PrintReceipt = false;
  StudentID='';
  SaveStudentRegistrationFee() {
    this.StudentPaymentModel.ChequeDate = this.StudentPaymentModel.ChequeDate != null && this.StudentPaymentModel.ChequeDate != '' ? moment(this.StudentPaymentModel.ChequeDate).format('DD-MMM-YYYY') : '';
   
    this.studentService.SaveStudentRegistrationFee(JSON.stringify(this.StudentPaymentModel)).subscribe((data) => {
      this.ReceiptNo = data.ReceiptNo;
      this.hidePrint = true;
      this.PrintReceipt = true;
      this.Clear();
      this.GetStudentByApplicationSubmitted();


    });
  }
  SaveStudentRegistration(valid) {
    this.SubmittedBasicDetails = true;
    this.loading = true;
    if (valid) {
      this.StudentEnquiryModel.DOB = this.StudentEnquiryModel.DOB != null && this.StudentEnquiryModel.DOB != '' ? moment(this.StudentEnquiryModel.DOB).format('DD-MMM-YYYY') : '';
      this.studentService.SaveStudentRegistration(JSON.stringify(this.StudentEnquiryModel), 'StudentDetails').subscribe((response) => {
        this.loading = false;
        this.GetStudentByApplicationSubmitted();
        this.globalHelper.CheckActionStatus(response);
        this.SubmittedBasicDetails = false;
        this.StudentEnquiryModel.StudentID = response.StudentID;


      });
    }

  }
  GetStudentByApplicationSubmitted() {
    this.spinnerService.show();
     this.StudentModel.SubFormDate = this.StudentModel.SubFormDate != null && this.StudentModel.SubFormDate != '' ? moment(this.StudentModel.SubFormDate).format('DD-MMM-YYYY') : '';
      this.StudentModel.SubToDate = this.StudentModel.SubToDate != null && this.StudentModel.SubToDate != '' ? moment(this.StudentModel.SubToDate).format('DD-MMM-YYYY') : '';
      this.StudentModel.TestFormDate = this.StudentModel.TestFormDate != null && this.StudentModel.TestFormDate != '' ? moment(this.StudentModel.TestFormDate).format('DD-MMM-YYYY') : '';
      this.StudentModel.TestToDate = this.StudentModel.TestToDate != null && this.StudentModel.TestToDate != '' ? moment(this.StudentModel.TestToDate).format('DD-MMM-YYYY') : '';
       this.studentService.GetStudentByApplicationSubmitted(JSON.stringify(this.StudentModel)).subscribe((data) => {
      this.StudentList = data.StudentList;
      this.spinnerService.hide();
    })
  }

 
  SaveParentsDetails(valid) {

    this.SubmittedParents = true;
    if (valid) {
      this.spinnerService.show();
      this.loadingParents = true;
      this.studentService.SaveStudentRegistration(JSON.stringify(this.StudentEnquiryModel), 'ParentsDetails').subscribe((response) => {

        this.loadingParents = false;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
        this.StudentEnquiryModel.StudentID = response.StudentID;
        this.GetStudentByApplicationSubmitted();
      });
    }
  }

  removeDocument(obj) {
    this.StudentDocumentModel.DocumentID = obj.DocumentID;
    this.studentService.UploadPhoto('', this.StudentEnquiryModel.StudentID, 'RemoveDocument', this.StudentDocumentModel.DocumentID, '').subscribe((response) => {
      this.globalHelper.CheckActionStatus(response);
      this.GetStudentByApplicationSubmitted();
      this.GetDocumentByStudentID(obj);
    })
  }
  GetDocumentByStudentID(obj) {

    this.StudentModel.FirstName = obj.FirstName;
    this.StudentModel.MiddleName = obj.MiddleName;
    this.StudentModel.LastName = obj.LastName;
    this.StudentModel.BODRegNo = obj.BODRegNo;
    this.StudentModel.StudentID = obj.StudentID;
    this.studentService.GetDocumentByStudentID(this.StudentModel.StudentID).subscribe((data) => {

      this.StudentDocumentList = data.StudentDocumentList;
      this.GetStudentByApplicationSubmitted();
    })

  }
  GetDocument() {
    var itembo = {
      'ItemID': this.StudentEnquiryModel.ClassID
    }
    this.lookupService.GetLookupsList('DocumentName', JSON.stringify(itembo)).subscribe((data) => {
      this.DocumentList = data.LookupItems;
    });
  };

  selectFileforStudentUpload(file) {
    this.SelectedFileForStudentUpload = file[0];
  };
  selectFileforFatherUpload(file) {
    this.SelectedFileForFatherUpload = file[0];
  };
  selectFileforMotherUpload(file) {
    this.SelectedFileForMotherUpload = file[0];
  };
  selectFileforDocumentUpload(file) {

    this.SelectedFileForDocumentUpload = file[0];
  };
  StudentPhotoUpload() {
    this.studentService.UploadPhoto(this.SelectedFileForStudentUpload, this.StudentEnquiryModel.StudentID, 'StudentPhoto', '', '').subscribe((response) => {
      this.globalHelper.CheckActionStatus(response);
      this.GetStudentProfileByStudentID();
    })
  }
  FatherPhotoUpload() {
    this.studentService.UploadPhoto(this.SelectedFileForFatherUpload, this.StudentEnquiryModel.StudentID, 'FatherPhoto', '', '').subscribe((response) => {
      this.globalHelper.CheckActionStatus(response);
      this.GetStudentProfileByStudentID();
    })

  }
  MotherPhotoUpload() {
    this.studentService.UploadPhoto(this.SelectedFileForMotherUpload, this.StudentEnquiryModel.StudentID, 'MotherPhoto', '', '').subscribe((response) => {
      this.globalHelper.CheckActionStatus(response);
      this.GetStudentProfileByStudentID();
    })

  }

  DocumentUpload() {
    for (var i = 0; i < this.StudentDocumentList.length; i++) {
      if (this.StudentDocumentList[i].DocumentID == this.StudentDocumentModel.DocumentID) {
        alert('document already uploaded');
        return;
      }


    }
    this.studentService.UploadPhoto(this.SelectedFileForDocumentUpload, this.StudentEnquiryModel.StudentID, 'StudentDocument', this.StudentDocumentModel.DocumentID, this.StudentDocumentModel.Notes).subscribe((response) => {
      this.globalHelper.CheckActionStatus(response);
      this.GetStudentProfileByStudentID()
    })

  }
  ValidateApplication() {

    return this.StudentEnquiryModel.Gender == "0" || this.StudentEnquiryModel.ClassID == 0||(this.StudentEnquiryModel.Active && this.StudentEnquiryModel.StudentNo=='')||(this.StudentEnquiryModel.Active && this.StudentEnquiryModel.AdmissionDate=='');
  };

  GetStudentProfileByStudentID() {

    this.studentService.GetStudentProfileByStudentID(this.StudentRegistrationModel.StudentID).subscribe((response) => {
      this.StudentView = response.StudentViewList;
      this.StudentEnquiryModel = this.StudentView.StudentDetails;
      this.StudentEnquiryModel.Address = this.StudentView.StudentDetails.Address;
      this.StudentEnquiryModel.ClassID = this.StudentView.StudentDetails.ClassID.toString().trim();
      this.StudentEnquiryModel.PrevClassID = this.StudentView.StudentDetails.PrevClassID.toString().trim();
      this.StudentEnquiryModel.IDCardTypeID = this.StudentView.StudentDetails.IDCardTypeID.toString().trim();
      this.StudentEnquiryModel.LocationID = this.StudentView.StudentDetails.LocationID.toString().trim();
      this.StudentEnquiryModel.CategoryID = this.StudentView.StudentDetails.CategoryID.toString().trim();
      this.StudentEnquiryModel.SpecialNeed = this.StudentView.StudentDetails.SpecialNeed;
      this.StudentEnquiryModel.SpecialCategoryID = this.StudentView.StudentDetails.SpecialCategoryID.toString().trim();
      this.StudentEnquiryModel.PresentStateID = this.StudentView.StudentDetails.PresentStateID;
      this.StudentEnquiryModel.ParentID = this.StudentView.StudentDetails.ParentID;
      this.StudentEnquiryModel.RelationShipID = this.StudentView.StudentDetails.RelationShipID;
      this.StudentEnquiryModel.EmailID = this.StudentView.StudentDetails.EmailID;
      this.StudentEnquiryModel.HouseName = this.StudentView.StudentDetails.HouseName;
      this.StudentEnquiryModel.DOB = moment(this.StudentView.StudentDetails.DOB).format("DD-MMM-YYYY");

      this.StudentEnquiryModel.PassportExpiryDate = this.StudentView.StudentDetails.PassportExpiryDate;
      this.StudentEnquiryModel.VisaExpiryDate = this.StudentView.StudentDetails.VisaExpiryDate;
      this.StudentEnquiryModel.PresentCityID = this.StudentView.StudentDetails.PresentCityID;
      //this.GetFeeInstallmentComponent();
      this.StudentDocumentList = this.StudentView.StudentDocumentList;
      this.CourseList = this.StudentView.CourseDetailsList;
      this.BrothersAndSistersList = this.StudentView.StudentSeblingList;
      this.CourseList = response.CourseList;


    });
  };
  SaveRegistrationApplication(valid) {
    this.SubmittedBasicDetails = true;
   
    if (valid && !this.ValidateApplication()) {

      this.spinnerService.show();
      this.StudentEnquiryModel.DOB = moment(this.StudentEnquiryModel.DOB).format("DD-MMM-YYYY");
      this.StudentEnquiryModel.AdmissionDate = moment(this.StudentEnquiryModel.AdmissionDate).format("DD-MMM-YYYY");
     
      this.studentService.SaveRegistrationApplication(JSON.stringify(this.StudentEnquiryModel)).subscribe((response) => {
        this.StudentID = response.StudentID;
        this.spinnerService.hide();
        this.Mesg = "";
        this.globalHelper.CheckActionStatus(response);
        this.SubmittedBasicDetails = false;
        this.loading = false;
        if (response.webResponse.Status) {
          this.ClearModel();
          this.GetStudentByApplicationSubmitted();
         
        }

      });
    }
  }
  Clear() {

    this.SubmittedBasicDetails = false;

  }
  GetSection() {
    this.StudentEnquiryModel.SessionID=0;
    var ItemBo = {
        'ItemId': this.StudentEnquiryModel.ClassID
    }
    this.lookupService.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe((data) => {
        this.SectionList = data.LookupItems;
        if (this.SectionList != null && this.SectionList.length>1) {
           this.StudentEnquiryModel.SectionID = this.SectionList[1].ItemId;       
          
      }

    });
};
  GetPresentCountry() {
    this.lookupService.GetLookupsList('Country', '').subscribe((data) => {
      this.PresentCountryList = data.LookupItems;
    });
  };
  GetPresentState() {
    var ItemBO = {
      ItemId: this.StudentEnquiryModel.PresentCountryID
    }

    this.lookupService.GetLookupsList('State', JSON.stringify(ItemBO)).subscribe((data) => {
      this.PresentStateList = data.LookupItems;
    });
  };
  GetPresentCity() {
    var itembo = {
      ItemID: this.StudentRegistrationModel.PermanentStateID
    }
    this.lookupService.GetLookupsList('City', JSON.stringify(itembo)).subscribe((data) => {
      this.PresentCityList = data.LookupItems;
    });
  };

  GetSpecialCategory() {

    this.lookupService.GetLookupsList('SpecialCategory', '').subscribe((data) => {
      this.SpecialCategoryList = data.LookupItems;


    });

  };
  GetCategory() {

    this.lookupService.GetLookupsList('Category', '').subscribe((data) => {
      this.CategoryList = data.LookupItems;


    });

  };
  GetLocation() {
    this.lookupService.GetLookupsList('Location', '').subscribe((data) => {
      this.LocationList = data.LookupItems;
    });
  };

  GetPermanentCountry() {

    this.lookupService.GetLookupsList('Country', '').subscribe((data) => {
      this.PermanentCountryList = data.LookupItems;
    });
  };
  GetPermanentState() {
    var ItemBO = {
      ItemId: this.StudentRegistrationModel.PermanentCountryID
    }

    this.lookupService.GetLookupsList('State', JSON.stringify(ItemBO)).subscribe((data) => {
      this.PermanentStateList = data.LookupItems;
    });
  };
  GetPermanentCity() {
    var itembo = {
      ItemId: this.StudentRegistrationModel.PermanentStateID
    }
    this.lookupService.GetLookupsList('City', JSON.stringify(itembo)).subscribe((data) => {
      this.PermanentCityList = data.LookupItems;
    });
  };

  GetAcademicSession() {
    var itembo = {
      'BranchID': this.StudentEnquiryModel.BranchID
    }

    this.lookupService.GetLookupsList('AcademicSession', JSON.stringify(itembo)).subscribe((data) => {
      this.AcademicSessionList = data.LookupItems;
    });
  };

  GetBranch() {
    this.lookupService.GetLookupsList('Branch', '').subscribe((data) => {
      this.BranchList = data.LookupItems;
    });
  };

  GetClass() {
    this.GetAcademicSession();


    var ItemBO = {
      BranchID: this.StudentEnquiryModel.BranchID
    }
    this.lookupService.GetLookupsList('Class', JSON.stringify(ItemBO)).subscribe((data) => {
      this.ClassList = data.LookupItems;
    });
  };

  GetBloodGroup() {

    this.lookupService.GetLookupsList('BloodGroup', '').subscribe((data) => {
      this.BloodGroupList = data.LookupItems;
    });
  };



  GetNationality() {

    this.lookupService.GetLookupsList('Nationality', '').subscribe((data) => {
      this.NationalityList = data.LookupItems;
    });
  };

  GetReligion() {

    this.lookupService.GetLookupsList('Religion', '').subscribe((data) => {
      this.ReligionList = data.LookupItems;


    });
  }
  GetMotherTongue() {

    this.lookupService.GetLookupsList('MotherTongue', '').subscribe((data) => {
      this.MotherTongueList = data.LookupItems;


    });
  }


  GetRelationship() {

    this.lookupService.GetLookupsList('Relationship', '').subscribe((data) => {
      this.RelationshipList = data.LookupItems;


    });
  }
  GetPaymentMode() {
    this.lookupService.GetLookupsList('PaymentMode', '').subscribe((data) => {
      this.PaymentModeList = data.LookupItems;

    });
  };
  GetBankCharges() {

    var BankCharges = 0;

    for (var i = 0; i < this.PaymentModeList.length; i++) {

      if (this.PaymentModeList[i].ItemId == this.StudentPaymentModel.PaymentModeID) {

        BankCharges = this.PaymentModeList[i].BankCharges;
      }

    }
    this.StudentPaymentModel.BankCharges = Math.round(BankCharges).toFixed(3);
    this.GetTotalWithCharges();

  }
  GetTotalWithCharges() {

    this.StudentPaymentModel.PaidAmount = this.StudentPaymentModel.PaidAmount + parseFloat(this.StudentPaymentModel.BankCharges);


  }
  BindBank() {
    this.lookupService.GetLookupsList('BankName', '').subscribe((response) => {
      this.BankList = response.LookupItems;
    });
  };
  BindBankBranch() {
    this.lookupService.GetLookupsList('Bank', '').subscribe((response) => {
      this.Bank = response.LookupItems;
      this.StudentPaymentModel.BankAccountID = 0;
    });
  };
  ngOnInit() {
   
    this.GetSpecialCategory();
    this.GetCategory();
    this.GetLocation();
    this.GetBranch();
    this.GetClass();
    this.GetReligion();
    this.GetRelationship();
    this.GetMotherTongue();
    this.GetIDCardType();
    this.GetNationality();
    this.GetBloodGroup();
    this.GetSection();
    this.GetTestVenue();
    this.GetPresentState();
    this.GetPaymentMode();
    this.BindBank();
    this.BindBankBranch();
    this.GetStream();
  
  }

  GetIDCardType() {

    this.lookupService.GetLookupsList('IDCardType', '').subscribe((data) => {
      this.IDCardTypeList = data.LookupItems;
    });
  }
  GetTestVenue() {
    this.lookupService.GetLookupsList('TestVenue', '').subscribe((data) => {
      this.TestVenueList = data.LookupItems;

    });

  };
  StreamList: any;
    GetStream() {

        this.lookupService.GetLookupsList('AllStream', '').subscribe((data) => {
            this.StreamList = data.LookupItems;
           
        });

    };
  Pay(obj) {

    this.StudentPaymentModel.FirstName = obj.FirstName;
    this.StudentPaymentModel.StudentID = obj.StudentID;
    this.StudentPaymentModel.ClassID = obj.ClassID;
    this.StudentPaymentModel.Amount = obj.Amount;
    this.StudentPaymentModel.MiddleName = obj.MiddleName;
    this.StudentPaymentModel.RegistrationNumber = obj.RegistrationNumber;
    this.ReceiptNo = obj.ReceiptNo;


  }
  XLSDownload() {
    this.StudentModel.Print = 'XLS';
    this.spinnerService.show();
    this.studentService.GetStudentByApplicationSubmitted(JSON.stringify(this.StudentModel)).subscribe((data) => {
      if (data.webResponse.Status) {
        this.FilePath = data.FilePath;
        window.location = data.FilePath;
      }
      this.spinnerService.hide();
    })
  }
  PrintFeeReceipt(ReceiptNo, PrintType, CopyType, Cancel) {

    this.hidePrint = false;
    var Template = this.globalHelper.GetLoginToken().FeeTemplate;
    if (Cancel == 'Yes') {
      let CopyType = 'C';
    }

    //   var url = "../../../../App/Template/FeeReceipt/" + Template + "?PrintType=FeeReceipt&ReceiptNo=" + ReceiptNo + "&PrintType=" + PrintType + "&CopyType=" + CopyType;
    var url = Template + "?PrintType=FeeReceipt&ReceiptNo=" + ReceiptNo + "&PrintType=" + PrintType + "&CopyType=" + CopyType;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  };


  CheckActionButton() {
    for (var k = 0; k < this.StudentList.length; k++) {
      if (this.StudentList[k].IsResult == true) {
        return this.IsResult = false;
      }
      else {
        this.IsResult = true;
      }
    }
  }
  CheckButtan() {
    for (var k = 0; k < this.StudentList.length; k++) {
      if (this.StudentList[k].IsTest == true) {
        return this.IsTest = false;
      }
      else {
        this.IsTest = true;
      }
    }
  }

  GetStudentID() {


    this.DefaultMailID = '';
    var j = 0;
    var StudentEmailIDs = '';
    for (var i = 0; i < this.StudentList.length; i++) {

      if (this.StudentList[i].IsTest == true) {

        var item = {
          StudentID: this.StudentList[i].StudentID
        }

        this.TestStudentList.push(item);

        if (StudentEmailIDs == '') {
          StudentEmailIDs = this.StudentList[i].EmailID
        }
        else if (StudentEmailIDs != '') {
          StudentEmailIDs = StudentEmailIDs + "," + this.StudentList[i].EmailID
        }

        if (j < 5) {
          j++;
          this.StudentModel.DefaultMailID = this.StudentModel.DefaultMailID == '' ? this.StudentList[i].EmailID : this.DefaultMailID + ';' + this.StudentList[i].EmailID
        }
        else if (i == this.StudentList.length - 1) {
          this.StudentModel.DefaultMailID = this.StudentModel.DefaultMailID + "..... " + this.StudentList[i].EmailID;
        }
      }

    }

    this.StudentModel.EmailIDs = StudentEmailIDs;
    
  }
  EnquiryList: any;
  GetEnquiryNo() {
    this.spinnerService.show();
    this.studentService.GetEnquiryNo(this.StudentEnquiryModel.EnquiryNo).subscribe((data) => {

      if (data.webResponse.Status) {
        this.EnquiryList = data.EnquiryDetails;

        this.StudentEnquiryModel.FirstName = data.EnquiryDetails.FirstName;
        this.StudentEnquiryModel.MiddleName = data.EnquiryDetails.MiddleName;
        this.StudentEnquiryModel.LastName = data.EnquiryDetails.LastName;
        this.StudentEnquiryModel.Mobile = data.EnquiryDetails.Mobile;
        this.StudentEnquiryModel.EmailID = data.EnquiryDetails.Email;
      }

    })
    this.spinnerService.hide();
  }

  Validation() {
    return this.StudentModel.TestDt == '';
}

ClearTest(){
  this.StudentModel.TestDt='';
  this.StudentModel.TestTime=moment(new Date()).format('DD-MMM-YYYY HH:mm');
  this.StudentModel.TestVenueID=0;
}
SubmitTest=false;
  UpdateTestAndVenue() {
    this.IsTest = true;
    this.IsResult = true;
    this.SubmitTest=true;
    this.StudentModel.TestDt = this.StudentModel.TestDt != null && this.StudentModel.TestDt != '' ? moment(this.StudentModel.TestDt).format('DD-MMM-YYYY') : '';
    this.StudentModel.TestTime = this.StudentModel.TestTime != null && this.StudentModel.TestTime != '' ? moment(this.StudentModel.TestTime).format('HH:mm') : '';
  
    if (!this.Validation()) {
     
      this.spinnerService.show(); 
      this.studentService.SendNotificationForAdmissionTest(JSON.stringify(this.StudentList), this.StudentModel.TestDt, this.StudentModel.TestTime, this.StudentModel.TestVenue, this.StudentModel.EmailIDs, this.StudentModel.CC, this.StudentModel.Subject).subscribe((data) => {
        // this.globalHelper.CheckActionStatus(data);
        })
             
       
        this.studentService.UpdateTestAndVenue(JSON.stringify(this.StudentModel), JSON.stringify(this.TestStudentList)).subscribe((data) => {
          this.SubmitTest=false;
          this.spinnerService.hide();   
          this.globalHelper.CheckActionStatus(data);
            this.GetStudentByApplicationSubmitted();
            this.StudentModel.TestTime=moment(new Date()).format('DD-MMM-YYYY HH:mm');
        })
    }
}
  ResultStudentList = [];
  UpdateProcedForAdmission() {
    this.IsTest = true;
    this.IsResult = true;
    for (var i = 0; i < this.StudentList.length; i++) {

      if (this.StudentList[i].IsResult == true) {
        var item = {
          StudentID: this.StudentList[i].StudentID
        }
        this.ResultStudentList.push(item);
      }
    }
    this.studentService.TestAction(JSON.stringify(this.ResultStudentList), 'ProcedForAdmission').subscribe((data) => {
      this.globalHelper.CheckActionStatus(data);
      this.ResultStudentList.splice(0, this.ResultStudentList.length);
      this.GetStudentByApplicationSubmitted();
    })
  }
  UpdateAdmissionGranted() {

    this.IsTest = true;
    this.IsResult = true;
    for (var i = 0; i < this.StudentList.length; i++) {

      if (this.StudentList[i].IsResult == true) {
        var item = {
          StudentID: this.StudentList[i].StudentID
        }
        this.ResultStudentList.push(item);
      }
    }
    this.spinnerService.show();
    this.studentService.TestAction(JSON.stringify(this.ResultStudentList), 'AdmissionGranted').subscribe((data) => {
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
      this.ResultStudentList.splice(0, this.ResultStudentList.length);
      this.GetStudentByApplicationSubmitted();
    })
  }
  UpdateRejected() {
    this.IsTest = true;
    this.IsResult = true;
    for (var i = 0; i < this.StudentList.length; i++) {

      if (this.StudentList[i].IsResult == true) {
        var item = {
          StudentID: this.StudentList[i].StudentID
        }
        this.ResultStudentList.push(item);
      }
    }
    this.spinnerService.show();
    this.studentService.TestAction(JSON.stringify(this.ResultStudentList), 'Rejected').subscribe((data) => {
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
      this.ResultStudentList.splice(0, this.ResultStudentList.length);
      this.GetStudentByApplicationSubmitted();
    })
  }
  UpdateAdmissionHold() {
    this.IsTest = true;
    this.IsResult = true;
    for (var i = 0; i < this.StudentList.length; i++) {

      if (this.StudentList[i].IsResult == true) {
        var item = {
          StudentID: this.StudentList[i].StudentID
        }
        this.ResultStudentList.push(item);
      }
    }
    this.spinnerService.show();
    this.studentService.TestAction(JSON.stringify(this.ResultStudentList), 'AdmissionHold').subscribe((data) => {
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
      this.ResultStudentList.splice(0, this.ResultStudentList.length);
      this.GetStudentByApplicationSubmitted();
    })
  }
  GetTestVenueName() {
    for (var i = 0; i < this.TestVenueList.length; i++) {
      if (this.TestVenueList[i].ItemId == this.StudentModel.TestVenueID) {
        this.StudentModel.TestVenue = this.TestVenueList[i].ItemName;

      }
    }
  }
  UpdatePreAdminssionRemarks(item) {

    this.spinnerService.show();
    this.studentService.UpdatePreAdminssionRemarks(item.PreAdminssionRemarks, item.StudentID).subscribe((data) => {
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    })
  }
}
